module.exports = __webpack_public_path__ + "img/restoration.1948be7b.jpg";